module.exports = __webpack_public_path__ + "img/img11.685cb3e9.svg";